import React, { Fragment, useEffect, useState } from 'react'
import BreadcrumbGlobal from '../../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import CodigoBoleto from '../../../../components/CodigoBoleto/CodigoBoleto'
import InlineLoader from '../../../../components/InlineLoader/InlineLoader'
import styled from 'styled-components'
import Card from '@taglivros/oef_componentes/build/components/card'
import Button from '@taglivros/oef_componentes/build/components/button'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import { useGlobal } from '../../../../contexts/GlobalContext'
import { useBoletoBancario } from '../../../../contexts/BoletoBancarioContext'
import { formatValor } from '../../../../utils/formatter/formatter'
import { isEmptyObject } from '../../../../utils/helpers/helpers'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../../utils/helpers/helpersAssinatura'
import { TITULO_PAGINA } from './constantsBoletoFuturo'
import { NOVO_BOLETO, PAGAMENTO_DO_BOLETO, DESCRICAO_INTERNET_BANKING, DESCRICAO_PAGAMENTO_LIBERACAO, VISUALIZAR_BOLETO } from '../constantsBoletoBancario'

const Titulo = styled.h1`
  margin: 5px 0 30px 0;

  @media ( max-width: ${StyleGuide.mediaQuery.mobile} ) {
    margin: 0 0 20px;
  }
`

const TituloNovoBoleto = styled.h3`
  margin: 0 0 10px;
`

const ValorTotal = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;

  .titulo__total {
    ${StyleGuide.tipografia.textoGrande}
    ${StyleGuide.boldFonte}

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 18px;
      margin-bottom: 0;
    }
  }

  .total {
    ${StyleGuide.tipografia.textoPequeno}
    color: ${StyleGuide.cores.cinza400};
    margin-left: 10px;

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      margin-left: 0;
      margin-top: 5px;
    }
  }
`

const WrapperMeses = styled.div`
  display: flex;

  p {
    margin: 0 0 20px 0;
  }

  p:not(:first-child) {
    margin-left: 5px;
  }
`

const DadosBoleto = styled.div`
  .titulo__pagamento {
    ${StyleGuide.tipografia.textoGrande};
    ${StyleGuide.boldFonte};
    margin: 0 0 20px;
  }

  .descricao__pagamento {
    color: ${StyleGuide.cores.cinza500};
  }
`

const ButtonWrapper = styled.div`
  margin: 20px 0;
`

const Wrapper = styled.div`
  .card {
    position: relative;

    @media( max-width: ${StyleGuide.mediaQuery.tablet} ) {
      margin: 0 0 20px;
      padding: 20px;
    }
  }
`

const BoletoFuturo = () => {
  const [ valorDoKit, setValorDoKit ] = useState()
  const [ valorTotal, setValorTotal ] = useState()
  const [ idAssinatura, setIdAssinatura ] = useState()
  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()
  const { codigoBarras, getBoleto, getInfosPagamento, infosPagamento, proximosMesesBoletoTrimestral, urlBoleto } = useBoletoBancario()

  useEffect( () => {
    if ( !isEmptyObject( infosPagamento ) ) {
      setValorDoKit( formatValor( { 'valor': infosPagamento.valorKit } ) )
      const total = infosPagamento.valorKit * 3
      setValorTotal( formatValor( { 'valor': total } ) )
    }
  }, [ infosPagamento ] )

  useEffect( () => {
    if ( dadosGlobaisAssociado ) {
      const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade( dadosGlobaisAssociado.assinaturas, modalidadeURL )

      if ( assinaturaObtida ) {
        setIdAssinatura( assinaturaObtida.id )
      }
    }
  }, [ dadosGlobaisAssociado ] )

  useEffect( () => {
    if ( idAssinatura ) {
      getBoleto( idAssinatura )
      getInfosPagamento( idAssinatura )
    }
  }, [ idAssinatura ] )

  return (
    <Fragment>
      <BreadcrumbGlobal
        exactPath="boleto-futuro"
        nomeAlternativo="Boleto futuro"
        padding="20px 0"
      />

      <Titulo>
        { TITULO_PAGINA }
      </Titulo>

      <Wrapper>
        <Card
          className="card"
          largura="calc(61% - 20px)"
          margin="0 0 30px 0"
        >
          <TituloNovoBoleto>
            { NOVO_BOLETO }
          </TituloNovoBoleto>

          <DadosBoleto>
            { proximosMesesBoletoTrimestral ?
              <WrapperMeses>
                <p> { 'Meses: ' } </p>

                <p className="meses">{ `${proximosMesesBoletoTrimestral[ 0 ]}, ${proximosMesesBoletoTrimestral[ 1 ]} e ${proximosMesesBoletoTrimestral[ 2 ]}` }</p>
              </WrapperMeses> : null}

            <p className="titulo__pagamento"> { PAGAMENTO_DO_BOLETO } </p>

            <p className="descricao__pagamento"> { DESCRICAO_INTERNET_BANKING } </p>
          </DadosBoleto>

          { codigoBarras ?
            <CodigoBoleto
              codigoBarrasBoleto={ codigoBarras }
            /> :
            <InlineLoader isCenter />}

          <DadosBoleto>
            <p className="descricao__pagamento"> { DESCRICAO_PAGAMENTO_LIBERACAO } </p>
          </DadosBoleto>

          <ValorTotal>
            <p className="titulo__total">
              { `Total: ${valorDoKit} /kit` }
            </p>

            <p className="total"> { `(Total: ${valorTotal})` } </p>
          </ValorTotal>

          { urlBoleto ?
            <ButtonWrapper>
              <Button
                href={ urlBoleto }
                tema={ Button.BOTAO_CURADORIA }
                type={ Button.TYPE_SUBMIT }
              >
                { VISUALIZAR_BOLETO }
              </Button>
            </ButtonWrapper> : null}
        </Card>
      </Wrapper>
    </Fragment>
  )
}

export default BoletoFuturo

